import React from 'react'
import { NavLink } from 'react-router-dom'

import { Disclosure } from '@headlessui/react'

const navigation = [
  // { name: 'OVERVIEW', href: '/overview', current: false },
  { name: 'BRAND', href: '/brand', current: false },
  { name: 'PRINCIPLES', href: '/principles', current: false },
  // { name: 'FOUNDATIONS', href: '/foundations', current: false },
  {
    name: 'Typography ',
    current: false,
    href: '/typography',
    children: [
      { name: 'Headings ', href: '/typography/headings', current: false },
      { name: 'Text ', href: '/typography/text', current: false },
      { name: 'Link ', href: '/typography/links', current: false }
      // { name: 'Forms', href: '/typography/forms', current: false  },
      // { name: 'Buttons', href: '/typography/buttons', current: false  },
      // { name: 'Other', href: '/typography/other', current: false  },
    ]
  },
  {
    name: 'Color ',
    current: false,
    href: '/color',
    children: [
      { name: 'Fills ', href: '/color/fills', current: false }
      // { name: 'Stroke', href: '/color/stroke', current: false  },
      // { name: 'Transparent', href: '/color/transparent', current: false  },
    ]
  },
  // {
  //   name: 'Form & Dimension',
  //   current: false,
  //   href: '/form-dimension',
  //   children: [
  //     { name: 'Borders', href: '/form-dimension/borders', current: false  },
  //     { name: 'Shadows', href: '/form-dimension/shadows', current: false  }
  //   ],
  // },
  {
    name: 'Spacing',
    current: false,
    href: '/spacing',
    children: [
      { name: 'Units', href: '/spacing/units', current: false }
      // { name: 'Insets', href: '/spacing/insets', current: false  },
      // { name: 'Stacks', href: '/spacing/stacks', current: false  },
      // { name: 'Grid Units', href: '/spacing/grid-units', current: false  }
    ]
  },
  {
    name: 'Assets ',
    current: false,
    href: '/assets',
    children: [
      { name: 'Icons ', href: '/assets/icons', current: false }
      // { name: 'Images', href: '/assets/images', current: false  }
    ]
  },
  { name: 'COMPONENTS', href: '/components', current: false },
  // {
  //   name: 'Layouts',
  //   current: false,
  //   href: '/layouts',
  //   children: [
  //     { name: 'Constrains / Containers', href: '/layouts/constrains', current: false  },
  //     { name: 'Breakpoints', href: '/layouts/breakpoints', current: false  },
  //     { name: 'Grid', href: '/layouts/grid', current: false  }
  //   ],
  // },
  {
    name: 'Form',
    current: false,
    href: '/Form',
    children: [
      { name: 'Button ', href: '/form/buttons', current: false },
      // { name: 'Checkbox', href: '/form/checkboxes', current: false },
      // { name: 'Radio', href: '#' },
      { name: 'Select', href: '/form/selects', current: false },
      { name: 'Autocomplete', href: '/form/autocomplete', current: false },
      { name: 'Input', href: '/form/inputs', current: false },
      { name: 'Checkbox', href: '/form/checkboxes', current: false }
      // { name: 'Text Area', href: '/form/text-area', current: false  }
    ]
  },
  {
    name: 'Overlay',
    current: false,
    href: '/overlay',
    children: [
      { name: 'Modal ', href: '/overlay/modal', current: false },
      { name: 'Menu', href: '/overlay/menu', current: false }
    ]
  },
  {
    name: 'Navigation',
    current: false,
    href: '/navigation',
    children: [
      { name: 'Header', href: '/navigation/header', current: false },
      { name: 'Breadcrumbs', href: '/navigation/breadcrumbs', current: false },
      { name: 'Disclosure', href: '/navigation/disclosure', current: false },
      { name: 'Sidenav', href: '/navigation/sidenav', current: false },
      { name: 'TabGroup', href: '/navigation/tabgroup', current: false }
    ]
  },
  // {
  //   name: 'Areas',
  //   current: false,
  //   href: '/areas',
  //   children: [
  //     { name: 'Card', href: '/areas/cards', current: false  },
  //   ],
  // },
  {
    name: 'Feedback ',
    current: false,
    href: '/feedback',
    children: [
      // { name: 'Progress', href: '/feedback/progress', current: false  },
      // { name: 'Dialogs', href: '/feedback/dialogs', current: false  },
      { name: 'Alerts ', href: '/feedback/alerts', current: false },
      { name: 'Empty State ', href: '/feedback/empty-state', current: false }
    ]
  },
  {
    name: 'Display ',
    current: false,
    href: '/display',
    children: [
      { name: 'Avatar', href: '/display/avatars', current: false },
      { name: 'Tag ', href: '/display/tags', current: false },
      // { name: 'Badge', href: '/display/badges', current: false  },
      { name: 'Table', href: '/display/tables', current: false }
      // { name: 'List', href: '/display/lists', current: false  },
      // { name: 'Tooltip', href: '/display/tooltips', current: false  },
      // { name: 'Content', href: '/display/content', current: false  },
    ]
  }
]
function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const SideNav = () => {
  return (
    <div className='overflow-y-auto pb-8 my-32 bg-white rounded left-0 w-1/4'>
      <div className='flex flex-col flex-grow pb-'>
        <div className='mt-4 flex-grow flex flex-col'>
          <nav className='flex-1 px-2 space-y-1' aria-label='Sidebar'>
            {navigation.map((item) =>
              !item.children ? (
                <div key={item.name}>
                  {(item.current = window.location.pathname === item.href)}
                  <NavLink
                    to={item.href}
                    className={classNames(
                      item.current && '',
                      'group w-full flex items-center pl-7 pr-2 py-2 text-sm rounded font-bold hover:bg-gray-100'
                    )}
                    activeClassName='text-white bg-primary hover:bg-primary'
                  >
                    {item.name}
                    {item.current}
                  </NavLink>
                </div>
              ) : (
                <Disclosure as='div' key={item.name} className='space-y-1 ml-6'>
                  {({ open }) => (
                    <>
                      {/* { item.current = window.location.pathname === item.href } */}
                      {/* { console.log(item.current) } */}
                      <Disclosure.Button
                        className={classNames(
                          item.current && '',
                          'group w-full flex items-center pr-2 py-2 text-left font-bold text-sm focus:outline-none focus:ring-2'
                        )}
                      >
                        <svg
                          className={classNames(
                            !open ? 'text-gray-400 rotate-90' : 'text-gray-300',
                            'mr-2 flex-shrink-0 h-5 w-5 transform transition-colors ease-in-out duration-150'
                          )}
                          viewBox='0 0 20 20'
                          aria-hidden='true'
                        >
                          <path d='M6 6L14 10L6 14V6Z' fill='currentColor' />
                        </svg>
                        {item.name}
                      </Disclosure.Button>
                      {!open && (
                        <div>
                          <Disclosure.Panel static className='space-y-1'>
                            {item.children.map((subItem) => (
                              <>
                                {/* { subItem.current = window.location.pathname === subItem.href } */}
                                <NavLink
                                  key={subItem.name}
                                  to={subItem.href}
                                  className={classNames(
                                    subItem.current
                                      ? ''
                                      : 'group w-full flex items-center rounded pl-10 pr-2 py-2 text-sm hover:bg-gray-100'
                                  )}
                                  activeClassName='text-white bg-primary group w-full flex items-center pl-10 pr-2 py-2 text-sm font-bold rounded-md hover:bg-primary'
                                >
                                  {subItem.name}
                                </NavLink>
                              </>
                            ))}
                          </Disclosure.Panel>
                        </div>
                      )}
                    </>
                  )}
                </Disclosure>
              )
            )}
          </nav>
        </div>
      </div>
    </div>
  )
}

export default SideNav
